/* eslint-disable react/no-danger */
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import useAPIError from '../../hooks/useAPIError';
// import { useAuthStore } from '../../store/AuthContext';
import { useAppStore } from '../../../store/AppContext';
import clubTarjeta from '../../../assets/images/club-tarjeta-bloque.png';
import { StorageHelper } from '../../../utils/StorageHelper';
import { CookieHelper } from '../../../utils/CookieHelper';
import useSessionChecking from '../../../hooks/useSessionChecking';
import { BackMappings } from '../../../utils/BackMappings';
import { useAuthStore } from '../../../store/AuthContext';
import { HostProvider } from '../../../utils/HostProvider';
import DataService from '../../../services/MisDatosService';
import { ErrorCodeConstants } from '../../../utils/ErrorCodeConstants';
import { useMisDatosStore } from '../../MisDatos/context/MisDatos.context';
import routerLoader from '../../../i18n/router';
import ModalConfirmacion from '../../../components/ModalConfirmacion';

const NoTitularEroski: FC = () => {
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.TARJETA);
  useSessionChecking(BackMappings.TARJETA, setGoOn, goOn);
  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const dataApp = useAppStore();
  const [messageError, setMessageError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [responseValidation, setResponseValidation] = useState<any>();

  const { showModalContactEmail, hideModalV2P } = useMisDatosStore();

  const handleSolicitarSocioClub = (e) => {
    DataService.checkPrevalidacionDatosAltaClub()
      .then((responsePrevalidacion) => {
        if (responsePrevalidacion.data.error) {
          setMessageError(
            t('tarjetas.tarjeta-socio.error-AME-prevalidation-message'),
          );
          setResponseValidation(responsePrevalidacion);
          setShowModal(true);
        } else {
          e.stopPropagation();
          e.preventDefault();
          StorageHelper.deleteUserFromSession();
          CookieHelper.removeUserCookies();
          document.location.href = `${HostProvider.getHost()}${
            dataApp.lang
          }/nlrRegistrar/noTitular/tarjetas?fromApp=${
            dataUser.user.fromApp
          }&origenAP=tarjetas`;
        }
      })
      .catch((er: any) => {
        console.log(er);
        setMessageError(t('nlr-vaya-algo-no-ha-ido-bien'));
        setShowModal(true);
      });
  };
  const gotoMisdatos = () => {
    if (
      responseValidation.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
    ) {
      StorageHelper.setOpenV2PFromOro();
      StorageHelper.setOpenDireccionHabitual();
    }
    if (
      responseValidation.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
    ) {
      StorageHelper.setOpenV2PFromOro();
      StorageHelper.setOpenOroPersonalData();
    }
    if (
      responseValidation.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
    ) {
      StorageHelper.setOpenV2PFromOro();
      StorageHelper.setOpenOroPersonalData();
    }
    if (
      responseValidation.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION
    ) {
      StorageHelper.setOpenTelefonoError();
    }
    if (
      responseValidation.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION
    ) {
      showModalContactEmail();
    }
    hideModalV2P();
    window.location.href = routerLoader.LoadRouterByPath(
      'mis-datos',
      dataApp.lang,
    );
  };

  if (goOn) {
    return (
      <>
        <section className="section header-tarjetas header-tarjetas__large tarjetas">
          <div className="container-inner">
            <div className="header-tarjetas__content">
              <h1 className="header-tarjetas__title">
                {t('tarjetas.sin-tarjeta.title')}
              </h1>
              {/* <p>{t('tarjetas.sin-tarjeta.advantages-card')}</p> */}
              <p
                dangerouslySetInnerHTML={{
                  __html: t('tarjetas.sin-tarjeta.advantages-card'),
                }}
              />{' '}
            </div>

            <ul className="header-tarjetas__lista u-text-white u-margin-top-giant-desktop">
              <li>{t('tarjetas.sin-tarjeta.hero-line-one')}</li>
              <li>{t('tarjetas.sin-tarjeta.hero-line-two')}</li>
              <li>{t('tarjetas.sin-tarjeta.hero-line-three')}</li>
            </ul>

            <div className="bloque-action__tarjeta">
              <p>{t('tarjetas.sin-tarjeta.request-it')}</p>
              <div className="img img-tarjeta_small">
                <img src={clubTarjeta} alt="Tarjeta Club" />
              </div>
              <p className="bloque-action__title">
                {t('tarjetas.sin-tarjeta.make-partner')}
              </p>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                className="btn btn-default"
                onClick={handleSolicitarSocioClub}
              >
                {t('tarjetas.sin-tarjeta.request-be-partner')}
              </a>
            </div>
          </div>
        </section>
        <section className="o-section--giant__top u-padding-bottom-hero section--background-img tarjetas">
          <div className="container-inner">
            <div className="u-display-flex-desktop u-justify-content-space-between u-align-items-start">
              <div className="tarjeta__content">
                <h2 className="bloque-datos__title">
                  <span className="divider__square brand-color" />
                  <span className="u-margin-right">
                    {t('tarjetas.sin-tarjeta.other-advantages')}
                  </span>
                </h2>

                <ul className="header-tarjetas__lista">
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t('tarjetas.sin-tarjeta.month-save'),
                    }}
                  />{' '}
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t('tarjetas.sin-tarjeta.digital-ticket'),
                    }}
                  />{' '}
                  <li
                    dangerouslySetInnerHTML={{
                      __html: t('tarjetas.sin-tarjeta.shop-and-tickets'),
                    }}
                  />{' '}
                </ul>
              </div>

              <div className="bloque-action__second">
                <p className="bloque-action__title">
                  {t('tarjetas.sin-tarjeta.have-card')}
                </p>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="#"
                  className="btn btn-primary calcular"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    StorageHelper.deleteUserFromSession();
                    CookieHelper.removeUserCookies();
                    document.location.href = `${HostProvider.getHost()}${
                      dataApp.lang
                    }/nlrRegistrar/titular/dadoalta/nocoincide/desdetarjetas?fromApp=${
                      dataUser.user.fromApp
                    }&origenAP=tarjetas`;
                  }}
                >
                  {t('tarjetas.sin-tarjeta.associate-card')}
                </a>
              </div>
            </div>
          </div>
        </section>{' '}
        <ModalConfirmacion
          isBig={false}
          isSmall
          textCentered
          showModal={showModal}
          setShowModal={setShowModal}
          title=""
          textHTMLContent={t(messageError)}
          doAceptar={gotoMisdatos}
          doClose={() => setShowModal(false)}
          showCancel={false}
          acceptButtonTextKey={t('datos.accessdata.accept')}
          hideXButton
        />
      </>
    );
  }
  return <></>;
};

export default NoTitularEroski;
